import Skeleton from '@mui/material/Skeleton';
import ArgonBox from 'components/ArgonBox';

function PageBlueHeaderSkeleton() {
  return (
    <ArgonBox pt={2} pb={0} sx={{ position: 'relative', zIndex: 1 }}>
      <Skeleton
        variant="text"
        sx={{
          width: { xs: '55%', sm: '32%' },
          height: { xs: 32, sm: 36 },
          bgcolor: 'rgba(255,255,255,0.28)',
          borderRadius: '6px',
        }}
      />
      <Skeleton
        variant="text"
        sx={{
          width: { xs: '90%', sm: '48%' },
          height: 20,
          mt: 1,
          bgcolor: 'rgba(255,255,255,0.18)',
          borderRadius: '4px',
        }}
      />
    </ArgonBox>
  );
}

export default PageBlueHeaderSkeleton;
